import {  _BusinessComment, BusinessCreateType, Business, ICreateBusinessComment, BusinessUpdateInterface, BusinessCommentUpdate, BusinessTable } from '@/entities/business';
import { Api } from './api/axios-config';
import { BusinessSourceService } from './BusinessSourceService';
import { CreateOrUpdateProductWithBusiness, CreateProductWithBusiness, UpdateProductWithBusiness } from '@/entities/businessProduct';

export class BusinessProductService {
  private static api = Api();
  
  public static async getBusinessProduct(businessId:number){
    const response = await this.api.get<any>(`/businessProduct/${businessId}`);
    if(response.status === 200){
      return response.data;
    }
  }

  public static async getAllBusinessProduct(){
    const response = await this.api.get<any>('businessProduct');
    if(response.status === 200){
      return response.data;
    } 
  }

  public static async updateBusinessProduct(businessProduct:UpdateProductWithBusiness){
    const response = await this.api.post<any>('/businessProduct/update',{
      id:businessProduct.id,
      quantity:businessProduct.quantity,
      price:businessProduct.price,
      discount:businessProduct.discount,
      total:businessProduct.total,
      businessId:businessProduct.businessId,
      productId:businessProduct.productId, 
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async createBusinessProduct(businessProduct:CreateProductWithBusiness){
    const response = await this.api.post<any>('/businessProduct/create', {
      quantity:businessProduct.quantity,
      price:businessProduct.price,
      discount:businessProduct.discount,
      total:businessProduct.total,
      deploy:businessProduct.deploy,
      businessId:businessProduct.businessId,
      productId:businessProduct.productId,
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async getInfosBusinessProduct(businessProductId: number) {
    const response = await this.api.get<any>(`/businessProduct/info/${businessProductId}`)
    return response;
  }

  public static async updateOrCreateBusinessProduct(businessProduct:CreateOrUpdateProductWithBusiness){
    const response =  await this.api.post<any>('/businessProduct/createOrUpdate',{
      id:businessProduct.id,
      quantity:businessProduct.quantity,
      price:businessProduct.price,
      discount:businessProduct.discount,
      deploy:Number(businessProduct.deploy),
      total:businessProduct.total,
      businessId:businessProduct.businessId,
      productId:businessProduct.productId,
    });
    if(response.status === 201){
      return response.data;
    }
  } 

  public static async deleteBusinessProduct(id:number){
    const response = await this.api.delete(`/businessProduct/delete/${id}`);
    if(response.status === 201){
      return response.data;
    }
  }

}
